'use client';

import dynamic from 'next/dynamic';

const ImageComparisonSlider = dynamic(
  () => import('../../microgrid/wet/components/ImageComparisonSlider'),
  { ssr: false }
);

export function WaterComparison() {
  return (
    <div className="relative overflow-hidden rounded-[20px] bg-gradient-to-b from-sky-200 via-sky-400 to-sky-600 p-3 text-white shadow-lg sm:rounded-[28px] sm:p-6 lg:p-8">
      <div className="absolute inset-x-0 bottom-0 h-20 bg-white/20 blur-3xl" />
      <div className="relative space-y-3 sm:space-y-5">
        <div className="text-center lg:text-left">
          <h3 className="text-base font-semibold sm:text-xl lg:text-2xl">Before & After: Everyday water moments.</h3>
          <p className="mt-1 text-xs text-white/80 sm:text-sm sm:mt-2">
            Slide between hard-water buildup and soft-water clarity to see the difference on surfaces, laundry, skin, and appliances.
          </p>
        </div>
        <div className="grid gap-3 sm:gap-5 lg:grid-cols-2">
          <div className="rounded-xl bg-white/10 p-2.5 sm:p-4">
            <p className="mb-1.5 text-xs uppercase tracking-[0.18em] text-white/90">Soap Scum</p>
            <ImageComparisonSlider beforeImg="/soap-scum_before.png" afterImg="/soap-scum_after.png" aspect="4/3" minHeight={0} />
          </div>
          <div className="rounded-xl bg-white/10 p-2.5 sm:p-4">
            <p className="mb-1.5 text-xs uppercase tracking-[0.18em] text-white/90">Appliances</p>
            <ImageComparisonSlider beforeImg="/appliance_scale.png" afterImg="/appliance_clean.png" aspect="4/3" minHeight={0} />
          </div>
        </div>
      </div>
    </div>
  );
}
